module.exports = __webpack_public_path__ + "img/cart_art.17a7c22e.svg";